export class UserAgentInfo {
  row = ''
  browserType = ''
  os = ''
  isAllowedGetInfo = false
  constructor(rowInfo) {
    this.row = rowInfo
    this.initRowInfo()
  }

  initRowInfo() {
    console.log(this.row)
    this.getBrowserType()
    this.getOperationSystem()
    this.isAllowedGetInfo = true
    console.log(this.os)
  }

  getBrowserType() {
    const ua = this.row.toLocaleLowerCase()
    // 1.包装链处理函数
    const isIEChain = new ResponsibleChain(this.isIE)
    const isFirefoxChain = new ResponsibleChain(this.isFirefox)
    const isUCChain = new ResponsibleChain(this.isUC)
    const isChromeChain = new ResponsibleChain(this.isChrome)
    const isBaiduChain = new ResponsibleChain(this.isBaidu)
    const isQQChain = new ResponsibleChain(this.isChrome)
    const isSafariChain = new ResponsibleChain(this.isSafari)
    const isOperaChain = new ResponsibleChain(this.isOpera)

    // 2.链接责任链
    isIEChain.setSuccessor(isFirefoxChain)
    isFirefoxChain.setSuccessor(isUCChain)
    isUCChain.setSuccessor(isChromeChain)
    isChromeChain.setSuccessor(isBaiduChain)
    isBaiduChain.setSuccessor(isQQChain)
    isQQChain.setSuccessor(isSafariChain)
    isSafariChain.setSuccessor(isOperaChain)
    // 3.执行责任链,获取最后的值
    this.browserType = isIEChain.passRequest(ua)
  }

  getOperationSystem() {
    let name = 'other'
    if (navigator.userAgent.indexOf('Win') != -1) name = 'Windows 操作系统'
    if (navigator.userAgent.indexOf('Mac') != -1) name = 'Macintosh 操作系统'
    if (navigator.userAgent.indexOf('Linux') != -1) name = 'Linux 操作系统'
    if (navigator.userAgent.indexOf('Android') != -1) name = 'Android 操作系统'
    if (navigator.userAgent.indexOf('like Mac') != -1) name = 'iOS'
    this.os = name
  }

  getUserOSinfo() {
    if (this.isAllowedGetInfo) {
      return { os: this.os, browserType: this.browserType }
    }
  }

  // 浏览器判断 链处理函数
  isIE(ua) {
    if (ua.match(/msie/) !== null || ua.match(/trident/) != null) {
      this.browserType = 'IE'
    } else {
      return 'nextSuccessor'
    }
  }

  isFirefox(ua) {
    if (ua.match(/firefox/) !== null) {
      this.browserType = 'firefox'
    } else {
      return 'nextSuccessor'
    }
  }

  isUC(ua) {
    if (ua.match(/ucbrowser/) !== null) {
      this.browserType = 'UC'
    } else {
      return 'nextSuccessor'
    }
  }

  isBaidu(ua) {
    if (ua.match(/bidubrowser/) != null) {
      return 'baidu'
    } else {
      return 'nextSuccessor'
    }
  }

  isQQ(ua) {
    if (ua.match(/tencenttraveler/) != null) {
      return 'QQ'
    } else {
      return 'nextSuccessor'
    }
  }

  isSafari(ua) {
    if (ua.match(/safari/) != null) {
      return 'Safari'
    } else {
      return 'nextSuccessor'
    }
  }

  isChrome(ua) {
    if (ua.match(/chrome/) !== null) {
      return 'chrome'
    } else {
      return 'nextSuccessor'
    }
  }

  isOpera(ua) {
    if (ua.match(/opera/) !== null || ua.match(/opr/) != null) {
      return 'opera'
    } else {
      return 'other'
      //链结尾
    }
  }

  // 判断操作系统/平台
}

// 责任链节点类
class ResponsibleChain {
  fn = null
  successor = null
  constructor(fn) {
    this.fn = fn
  }

  setSuccessor(successor) {
    this.successor = successor
  }

  passRequest() {
    let ret = this.fn.apply(this, arguments)
    if (ret === 'nextSuccessor') {
      return (
        this.successor &&
        // 第二行passrequest非常重要
        this.successor.passRequest.apply(this.successor, arguments)
      )
      // 注意this.successor都是保存的chain类型,所以可以执行
    }
    return ret
  }
}
